<template>
  <div id="app">
    <router-view ref="view"/>
  </div>
</template>
<script>
import { getStatus } from "@/api/user.js";
import { getToken } from "@/utils/auth";
export default {
  data(){
    return {
      page:""
    }
  },
  updated() {
    this.page = this.$route.path
    this.qStatus = this.$route.query.status;
    let token = getToken();
    if (token && this.page != "/") {
      // 个人用户跳过学校注册状态检查，直接留在当前页面
      const role = window.localStorage.getItem("role");
      if (role === "1") {
        return;
      }
      this.getStatus();
    }
    else if (this.page != "/") {
      this.$router.push("/")
    }
  },
  methods: {
    getStatus() {
      getStatus().then((d) => {
        let status = d.data.status;
        let remark = d.data.remark;
        if (status == -1 && this.page !== "/reg") { //审核状态是 未报名 并且页面不在 报名页面 时 跳转到报名页面
          this.$router.push("/reg");
        } else if (status == 1 && (this.page == "/reg" || this.page == "/info")) { //审核状态是 已通过 并且页面在 注册 或 提示 时 跳转到学校主页面
          this.$router.push("/main");
        } else if(status == 0 && this.qStatus != 0 ) { //审核状态是 待审核 并且页面不在 提示-待审核 时 跳转到 提示-待审核
          this.$router.push({ path: "/info", query: { status } });
        }
        else if(status == 2 && this.qStatus != 2 && this.page != "/reg" ) { //审核状态是 已拒绝 并且页面不在 提示-已拒绝 并且也不在 报名页面 时 跳转到 提示-已拒绝
          this.$router.push({ path: "/info", query: { status , remark } });
        }
      });
    },
  },
};
</script>
<style lang="scss">
@import "~@/style/main.scss";
</style>